<div
  class="desktop row d-flex align-items-center m_t"
  style="background-color:#00095B;color:#3569B6;padding-bottom:60px !important">

  <div class="col-lg-6 col-md-6 col-sm-12">
    <img
      style="margin-left:10px"
      class="navbar-brand"
      [src]="getFilePath(school?.schImg?.fileUUID)"
      alt="School Logo"
      height="50px">
  </div>

  <div class="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-end mt-2">
    <h2 class="text-light p-2 mx-2">Need help?</h2>

    <div>
      <button
        type="button"
        class="cnt_btn btn bg-light px-3 mx-1"
        (click)="contact()">
        <b>Contact Us</b>
      </button>
    </div>
  </div>

  <div
    class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center mt-4"
    style="color:white;">

    <div class="d-flex mx-2">
      <a class="txt" target="_blank">
        <h5 style="color:white;">Privacy Policy</h5>
      </a>

      <h5 class="mx-2">.</h5>

      <a class="txt" target="_blank">
        <h5 style="color:white;">Terms & Conditions</h5>
      </a>
    </div>
  </div>

  <div class="col-lg-6 col-md-6 justify-content-end mt-4 d-flex">

    <button
      class="btn bg-light mx-3 btn-icon"
      (click)="openExternalLink(instagramContent?.content)">
      <i class="fab fa-instagram"></i>
    </button>

    <button
      class="btn bg-light mx-3 btn-icon"
      (click)="openExternalLink(facebookContent?.content)">
      <i class="fab fa-facebook-f"></i>
    </button>

    <button
      class="btn bg-light mx-3 btn-icon"
      (click)="openExternalLink(youtubeContent?.content)">
      <i class="fab fa-youtube"></i>
    </button>

  </div>

</div>

<!-- Mobile Footer -->

<div
  class="mobile row d-flex align-items-center m_t"
  style="background-color:#00095B;color:#3569B6;padding-bottom:60px !important">

  <div class="col-sm-12">
    <img
      style="margin-left:5px"
      class="navbar-brand"
      [src]="getFilePath(school?.schImg?.fileUUID)"
      alt="School Logo"
      height="30px">
  </div>

  <div
    class="col-sm-12 d-flex align-items-end mt-3 mobile"
    style="color:white;">

    <div class="d-flex mx-2">
      <h6>Privacy Policy</h6>
      <h6 class="mx-2">.</h6>
      <h6>Terms & Conditions</h6>
    </div>
  </div>

  <div class="col-sm-12 mt-2 d-flex justify-content-center">

    <button
      class="btn bg-light mx-1 btn-icon"
      (click)="openExternalLink(instagramContent?.content)">
      <i class="fab fa-instagram"></i>
    </button>

    <button
      class="btn bg-light mx-3 btn-icon"
      (click)="openExternalLink(facebookContent?.content)">
      <i class="fab fa-facebook-f"></i>
    </button>

    <button
      class="btn bg-light mx-3 btn-icon"
      (click)="openExternalLink(youtubeContent?.content)">
      <i class="fab fa-youtube"></i>
    </button>

  </div>

</div>